<script setup lang="ts">
import { Card } from '@metapic-apps/shared'
import { computed } from 'vue'

import { mapAdvertiserTypeName } from '@/components/Advertiser/Advertiser.helpers'
import CostDataRow from '@/components/CampaignListItem/CostDataRow.vue'
import type { AdvertiserLegacyType } from '@/lib/types/advertiser.types'
import { BoxComponent, FlexComponent, ImageComponent, TypographyComponent } from '@/ui-library'

const props = defineProps<{
  advertiser: AdvertiserLegacyType
}>()
const advertiserGroup = computed(() => props.advertiser.advertiserGroups?.[0])
</script>

<template>
  <Card>
    <FlexComponent :gap="24">
      <BoxComponent class="logo" :w="128" :h="128" :p="1">
        <ImageComponent :image="advertiser.logo" :width="124" :alt="advertiser.name" :height="124" />
      </BoxComponent>
      <FlexComponent direction="column" :gap="4">
        <TypographyComponent variant="headline-small">
          {{ advertiser.name }}
        </TypographyComponent>
        <FlexComponent align="center">
          <TypographyComponent variant="body-small" color="var(--secondary-48)">ID: {{ advertiser.id }}</TypographyComponent>
          <BoxComponent :ml="8" :mr="8">
            <TypographyComponent variant="body-small" color="var(--secondary-48)">|</TypographyComponent>
          </BoxComponent>
          <TypographyComponent variant="body-small" color="var(--secondary-48)">{{ advertiserGroup?.name }}</TypographyComponent>
          <BoxComponent :ml="8" :mr="8">
            <TypographyComponent variant="body-small" color="var(--secondary-48)">|</TypographyComponent>
          </BoxComponent>
          <TypographyComponent variant="body-small" color="var(--secondary-48)">Locale: {{ advertiser.language }}</TypographyComponent>
        </FlexComponent>
        <FlexComponent :gap="8">
          <TypographyComponent variant="title-medium"> Provider: </TypographyComponent>
          <TypographyComponent variant="body-medium"> {{ advertiser.provider }} </TypographyComponent>
        </FlexComponent>
        <FlexComponent :gap="8">
          <TypographyComponent variant="title-medium"> Type: </TypographyComponent>
          <TypographyComponent variant="body-medium"> {{ mapAdvertiserTypeName(advertiser.type) }} </TypographyComponent>
        </FlexComponent>
        <FlexComponent :gap="8" align="center">
          <TypographyComponent variant="title-medium"> Commission: </TypographyComponent>
          <CostDataRow
            v-if="advertiser.trafficSourceCosts?.length"
            :currency="advertiser.currency"
            :grouped-traffic-source-costs="advertiser.trafficSourceCosts"
            justify-content="center"
          />
        </FlexComponent>
      </FlexComponent>
    </FlexComponent>
  </Card>
</template>

<style scoped>
.logo {
  border-radius: 16px;
  border: 1px solid var(--secondary-8);

  img {
    object-fit: contain;
    border-radius: 16px;
  }
}
</style>
